<template>
  <b-modal :id="id" v-model="showModal" size="xl" @hidden="cancelar" @close="cancelar" button-size="md" hide-footer
    :title="prefix + title">
    <LocalArmazenamentoList :idFinderLocal="id + '-list'" :prefix="prefix + title + ' > '" :idPai="idPai">
    </LocalArmazenamentoList>
  </b-modal>
</template>
<script>
export default {
  components: {
    LocalArmazenamentoList: ()=>import("@/modules/cadastros/local-armazenamento/LocalArmazenamentoList.vue")
    ,
  },
  name: "ModalPageLocalArmazenamento",
  props: {
    id: {
      type: String,
      default: "",
    },
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "LocalArmazenamento",
    },
    idPai:
      { type: Number, default: null },
  },

  data() {
    return {
      showModal: true,
    }
  },

  beforeMount() {
  },

  methods: {
    cancelar() {
      this.$emit("close")
    },
  },
}
</script>
